import React from 'react';
import LegalPage from './LegalPage';
import privacyData from '../data/privacyPolicy';

const PrivacyPolicy = () => <LegalPage data={privacyData} />;

export default PrivacyPolicy;
